import { ApiResponseError } from '@round/api';
import { FormikErrors } from 'formik';

export function mapApiErrorsToFormikErrors<T extends Record<string, any>>(
    apiErrors: ApiResponseError<T>
): FormikErrors<T> {
    return Object.keys(apiErrors).reduce((formikErrors, key) => {
        const value = apiErrors[key as keyof ApiResponseError<T>];
        return {
            ...formikErrors,
            [key]: typeof value === 'string' ? value : value?.join(''),
        };
    }, {} as FormikErrors<T>);
}
